import { render, staticRenderFns } from "./RectShape.vue?vue&type=template&id=f6e8a228&scoped=true&"
import script from "./RectShape.vue?vue&type=script&lang=js&"
export * from "./RectShape.vue?vue&type=script&lang=js&"
import style0 from "./RectShape.vue?vue&type=style&index=0&id=f6e8a228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e8a228",
  null
  
)

export default component.exports